import { powerSyncDb } from "./db"

/** Recover associations after a process exit between promotion transactions. */
export async function reconcileGeospatialPhotoAssociations(): Promise<void> {
  await powerSyncDb.writeTransaction(async (tx) => {
    const stranded = `FROM local_geospatial_data_photos lp
      WHERE EXISTS (SELECT 1 FROM geospatial_data gd WHERE gd.id = lp.geospatial_data_id)
        AND NOT EXISTS (SELECT 1 FROM local_geospatial_data lgd WHERE lgd.id = lp.geospatial_data_id)`
    await tx.execute(
      `INSERT OR REPLACE INTO geospatial_data_photos
         (id, geospatial_data_id, photo_id, project_id, created_at)
       SELECT lp.id, lp.geospatial_data_id, lp.photo_id, lp.project_id, lp.created_at
       ${stranded}`,
    )
    await tx.execute(
      `DELETE FROM local_geospatial_data_photos
       WHERE id IN (SELECT lp.id ${stranded})`,
    )
  })
}
